// src/pages/Home/sections/HeroSection.js

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import bgImage from "assets/images/hero-bg.jpg";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export default function HeroSection({ isLoggedIn }) {
  const { t } = useTranslation();

  return (
    <MKBox
      minHeight="62vh"
      width="100%"
      sx={({ breakpoints }) => ({
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        display: "grid",
        placeItems: "center",
        [breakpoints.down("md")]: {
          minHeight: "62vh", // increase height on narrow screens
          paddingTop: "4rem", // extra space at the top on mobile
          paddingBottom: "1rem", // extra space at the bottom on mobile
        },
      })}
    >
      <Container>
        <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
          <MKTypography
            variant="h1"
            color="white"
            mb={1}
            textAlign="center"
            sx={({ breakpoints, typography: { size } }) => ({
              mt: {
                xs: 0, // no extra space on narrow screens
                md: -6, // original offset only on wide screens
              },
              [breakpoints.down("md")]: {
                fontSize: size["3xl"],
              },
            })}
          >
            {t("hero.title")}
          </MKTypography>

          <MKTypography
            variant="body1"
            color="white"
            textAlign="center"
            px={{ xs: 6, lg: 12 }}
            mt={1}
          >
            {t("hero.subtitle")}
          </MKTypography>

          {/* 注册按钮 */}
          <Grid container item xs={12} justifyContent="center" mt={4}>
            <MKBox>
              <MKButton
                component="a"
                href={isLoggedIn ? "/userinfo/" : "/signup/"}
                variant="gradient"
                color="success"
                size="large"
                sx={{
                  px: 3,
                  py: 2,
                  fontWeight: 900,
                  fontSize: "1.35rem",
                  color: "#ffffff",
                  background: "linear-gradient(195deg, #43a047, #2e7d32)",
                  boxShadow: "0 4px 8px 2px rgba(67, 160, 71, 0.35)",
                  "&:hover": {
                    background: "linear-gradient(195deg, #4caf50, #2e7d32)",
                  },
                }}
              >
                {isLoggedIn ? t("nav.userCenter") : t("hero.free_register")}
              </MKButton>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

HeroSection.propTypes = {
  isLoggedIn: PropTypes.bool,
};
